import { ElectronApi } from '@/services/electron.api';
import { ref } from 'vue';

const _isIntranet = ref(false);
export const useIsIntranet = () => {
  const testIsIntranet = async () => {
    // 仅pro版本下验证是否外网
    if (ElectronApi.isNormal()) {
      _isIntranet.value = false;
      return;
    }

    const url =
      'https://cnbj1-fds.api.xiaomi.net/watchface-editor-release/is-intranet.md?_random=' +
      Date.now();
    try {
      await window
        .fetch(url, { cache: 'no-store' })
        .then((r) => {
          _isIntranet.value = r.ok ? true : false;
        })
        .catch(() => (_isIntranet.value = false));
    } catch (error) {
      _isIntranet.value = false;
    }
  };
  return {
    isIntranet: _isIntranet,
    testIsIntranet
  };
};
